import { css } from '@emotion/react'
import { Branding, Story } from '../types'
import {
  addCloudfrontUrl,
  defaultRiskStoryCoverImage,
  primaryContrastDefault,
  primaryDefault,
  secondaryContrastDefault,
  secondaryDefault,
} from './Stories.utils'

export const landingPageContainer = (story: Story | null) => css`
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: ${story?.branding?.primaryContrast ?? primaryContrastDefault};
  background-color: ${story?.branding?.primary ?? primaryDefault};
  background-image: url('${addCloudfrontUrl(
    story?.coverImageUrl ? story?.coverImageUrl : defaultRiskStoryCoverImage,
  )}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`

export const startPresentationButton = (branding: Branding | undefined) => css`
  color: ${branding?.secondaryContrast ?? secondaryContrastDefault};
  background-color: ${branding?.secondary ?? ''};
  &:hover {
    background-color: ${branding?.primaryContrast ?? primaryContrastDefault};
    color: ${branding?.primary ?? primaryDefault};
  }
`
export const landingPageContent = (branding: Branding | undefined) => css`
  max-width: 924px;
  padding: 60px;
  background-color: ${branding?.primary ?? primaryDefault};
  color: ${branding?.primaryContrast ?? primaryContrastDefault};
  border-radius: 30px;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;

  h1 {
    padding-top: 52px;
    padding-bottom: 10px;
    font-size: 44px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: 0.88px;
  }

  button {
    margin-top: 24px;
    background-color: ${branding?.secondary ?? secondaryDefault};
    color: ${branding?.secondaryContrast ?? secondaryContrastDefault};
  }
`
export const clientLogoWrapper = css`
  display: flex;
  flex-direction: row;
  justify-content: right;
  width: 100%;
`

export const logo = () => css`
  height: 53px;
`
